import { render, staticRenderFns } from "./Negative.vue?vue&type=template&id=4c952f64&scoped=true&"
import script from "./Negative.vue?vue&type=script&lang=ts&"
export * from "./Negative.vue?vue&type=script&lang=ts&"
import style0 from "./Negative.vue?vue&type=style&index=0&id=4c952f64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c952f64",
  null
  
)

export default component.exports